import { Paper, Box, Button, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from 'react-redux'
import FileBase from 'react-file-base64'

import useStyles from './styles'
import { createProduct } from "../../../actions/productActions";

const Form = () => {

    const [formData, setFormData] = useState({title:'', category:'', quantity: 0, selectedFile: ''})

    const classes = useStyles()
    const dispatch = useDispatch()
    const retailer = JSON.parse(localStorage.getItem('retailer'))

    const clear = () => {
        setFormData({title:'', category:'', quantity: 0, selectedFile: ''})
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch(createProduct({...formData, name: retailer?.user.name}))
        clear()
    }

    return ( 

    <Paper className={classes.paper} elevation={3}>    
    <Box
    onSubmit={handleSubmit}
    component="form"
    sx={{
        '& .MuiTextField-root': { margin: '.4rem', width: '96%' }
    }}
    noValidate
    autoComplete="off"
    >
    <Typography variant='h5' gutterBottom align='center'>Adding a product</Typography>
      <div>
        <TextField required fullWidth name='title' label='Title' value={formData.title} onChange={(e)=> setFormData({...formData, title: e.target.value})} />
            <div className={classes.selectDiv}>
                <select required className={classes.select} name="category" onChange={(e)=> setFormData({...formData, category: e.target.value})} >
                <option>Category</option>
                <option value="fruits">Fruits</option>
                <option value="toiletries">Toiletries</option>
                <option value="drinks">Drinks</option>
            </select>
            </div>
            <TextField required fullWidth type='number' name='quantity' label='Quantity' value={formData.quantity} onChange={(e)=> setFormData({...formData, quantity: e.target.value})} />
      </div>

    <div>
        <FileBase required type='file' multiple={false} className={classes.fileBase}  fullWidth onDone={({base64}) => setFormData({...formData, selectedFile: base64})} />
    </div>
    <div>
        <Button className={classes.button} fullWidth size='small' color='primary' type='submit' variant='contained' >SUBMIT</Button>
        <Button className={classes.button} fullWidth size='small' color='secondary' onClick={clear}
        variant='contained' >CLEAR</Button>
    </div>
    </Box>
    </Paper>
     );
}
 
export default Form;